'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Loading, _React$Component);

  function Loading(props) {
    (0, _classCallCheck3.default)(this, Loading);
    return (0, _possibleConstructorReturn3.default)(this, (Loading.__proto__ || (0, _getPrototypeOf2.default)(Loading)).call(this, props));
  }

  (0, _createClass3.default)(Loading, [{
    key: 'render',
    value: function render() {
      var loadingClass = (0, _classnames2.default)({
        'loading': true,
        'visible': this.props.visible
      });

      return _react2.default.createElement(
        'div',
        { className: loadingClass },
        _react2.default.createElement(
          'div',
          { className: 'table' },
          _react2.default.createElement(
            'div',
            { className: 'cell' },
            _react2.default.createElement(
              'div',
              { className: 'icon-polygon rotating' },
              _react2.default.createElement(
                'span',
                { className: 'rotatingTwo' },
                'CARGANDO'
              )
            )
          )
        )
      );
    }
  }]);
  return Loading;
}(_react2.default.Component), _class.propTypes = {
  name: _propTypes2.default.string
}, _temp);
exports.default = Loading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.jsx
// module id = 704
// module chunks = 0